// src/components/TestFileUpload.jsx
import React, { useState } from "react";
import { API_BASE } from "../services/api";

const TestFileUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch(`${API_BASE}/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setMessage(data?.message || "Upload successful.");
    } catch (error) {
      console.error("Upload failed", error);
      setMessage("Upload failed. Check console for details.");
    }
  };

  return (
    <div className="mx-auto mt-8 max-w-md rounded-2xl bg-white p-6 shadow-lg">
      <h2 className="text-lg font-semibold text-slate-900">Test file upload</h2>
      <p className="mt-2 text-sm text-slate-500">This tool helps confirm that uploads are working correctly.</p>

      <div className="mt-4">
        <input type="file" onChange={(event) => setSelectedFile(event.target.files?.[0] || null)} />
      </div>

      <button
        onClick={handleUpload}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
      >
        Upload file
      </button>

      {message && <p className="mt-3 text-sm text-slate-600">{message}</p>}
    </div>
  );
};

export default TestFileUpload;
